import React, {Component} from 'react'
import "./pagination.scss"
import Icon from "../icon/icon.component.jsx";
import {FormattedMessage} from "react-intl";

class SortLink extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            field: this.props.field || '',
            sortField: this.props.sortField || '',
            asc: this.props.asc || false,
            onChange: this.props.onChange || function() {},
        }
        this.updateSorting = this.updateSorting.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            field: nextProps.field || '',
            sortField: nextProps.sortField || '',
            asc: nextProps.asc || false,
        })
    }

    updateSorting(e) {
        e.preventDefault()
        let asc = this.state.asc
        if (this.state.field === this.state.sortField) {
            asc = !asc
        }
        this.setState({
            sortField: this.state.field,
            asc: asc,
        }, () => {
            this.state.onChange(this.state.sortField, this.state.asc)
        })
    }

    render() {
        const sortIcon = <Icon value={this.state.asc ? 'sort-up' : 'sort-down'} className={'ml-1'} />
        return <a href={'#'} onClick={this.updateSorting}>
            {this.props.children}
            {this.state.sortField === this.state.field ? sortIcon : ''}
        </a>
    }
}

export default SortLink





// WEBPACK FOOTER //
// ./src/common/listing/sortlink.component.jsx